import React, { useState } from "react";
import styles from "./NavBar.module.css";
import NavTwo from "./NavTwo";
import Link from "next/link";
import router from "next/router";
import { handleLinkClick } from "@/Config/helper";
import UnifiedLoginUser from "../UnifiedLoginUser/UnifiedLoginUser";

interface NavBarOneProps {
  handleEnrollButtonClick: () => void;
  handleBroutcherButtonClick: (broutcherLink?: string) => void;
  pageTitle?: any;
  popUpData?: any;

  data?: {
    nav_links?: Array<{
      id?: number;
      label?: string;
      url: string;
    }>;
  };
}

const NavOne: React.FC<NavBarOneProps> = ({
  handleEnrollButtonClick,
  handleBroutcherButtonClick,
  pageTitle,
  popUpData,
  data,
}) => {
  const navLinks = data?.nav_links || [];

  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [step, setStep] = useState(1);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    // setStep(1);
  };

  return (
    <nav className={styles.navBar} data-section="Navbar">
      <div className={styles.navOneContainer}>
        <div className={styles.navOne}>
          {navLinks?.map((link) => {
            const shouldOpenInNewTab =
              link?.url === "https://regenius.regenesys.net/login/index.php" ||
              link?.url === "https://www.regenesys.net/reginsights";

            return (
              <Link
                key={link?.id || link?.url}
                href={link?.url || "#"}
                className={styles.navLink}
                target={shouldOpenInNewTab ? "_blank" : undefined}
                rel={shouldOpenInNewTab ? "noopener noreferrer" : undefined}
                onClick={(e) => handleLinkClick(e, link.url, router)}
                title={link?.label}
              >
                {link?.label}
              </Link>
            );
          })}
          <p className={styles.userLogin} onClick={handleOpenModal}>
            Login
          </p>
        </div>
      </div>

      <NavTwo
        pageTitle={pageTitle}
        handleEnrollButtonClick={handleEnrollButtonClick}
        data={data}
        handleBroutcherButtonClick={handleBroutcherButtonClick}
        popUpData={popUpData}
      />

      <UnifiedLoginUser isOpen={isModalOpen} onClose={handleCloseModal} />
    </nav>
  );
};

export default NavOne;
